// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*purgecss start ignore*/\n::-webkit-scrollbar{\n  width:7px\n}\n::-webkit-scrollbar-thumb{\n  background:#1a5cac\n}\n::-webkit-scrollbar-thumb:hover{\n  background:#1a5cac;\n  opacity:.9\n}\n::-webkit-scrollbar-track{\n  background:#fafafa\n}\n\n/*purgecss end ignore*/", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
